import {
  getEventTitle,
  getPreliminaryInvoice,
  getTaxConfig,
  isAssignedTickets,
  isDateTbd,
} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {ReservationState} from '../../../../../commons/enums'
import {isTemplate} from '../../../../../commons/selectors/instance'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {OrderSuccessRuntimeProps} from './interfaces'
import {OrderSuccess as Presentation} from './order-success'

const mapRuntime = ({
  state,
  actions: {ticketedThankYouPageLoaded, navigateToMainPage},
}: DetailsPageAppProps): OrderSuccessRuntimeProps => {
  const {event, checkout} = state
  const template = isTemplate(state)
  const order = template
    ? {
        firstName: checkout.buyerDetails.firstName,
        email: checkout.buyerDetails.email,
        formattedCreatedDate: state.dates.common.nowYearMonthDayFormatted,
        invoice: getPreliminaryInvoice(state.tickets, state.selectedTickets, getTaxConfig(state.event)),
      }
    : state.placedOrder.order

  return {
    order,
    formattedOrderCreatedDate: state.dates.common.formattedOrderCreatedDate,
    eventTitle: getEventTitle(event),
    dateTbd: isDateTbd(event),
    isAssignedTickets: isAssignedTickets(event),
    taxConfig: getTaxConfig(event),
    template,
    navigateToMainPage,
    orderPending: state.navigation.reservationState === ReservationState.PENDING,
    ticketedThankYouPageLoaded,
  }
}

export const OrderSuccess = connect<{}, OrderSuccessRuntimeProps>(mapRuntime)(withTranslation()(Presentation))

export * from './interfaces'
